import HeaderService from "./HeaderService";
export default {
  mixins: [HeaderService],
  props: {
    urlSair: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      objetoUsuarioHeader: {},
      fotoPerfil: require("@/shared/assets/imagens/user.png")
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    clickBotoes(index) {
      switch (index) {
        case 0: {
          this.sairHeader();
          break;
        }
        default:
          this.sairHeader();
      }
    },
    sairHeader() {
      this.$store.dispatch("resetarLocalStorage");
      window.open(this.urlSair, "_self");
    },
    redirecionarHome() {
      this.$router.push("/home");
    },
    init() {
      this.getFotoPerfil()
        .then(res => {
          if (res.data.size === 0) return;
          let blob = new Blob([res.data], {
            type: "image/png"
          });
          let url = URL.createObjectURL(blob);
          this.fotoPerfil = url;
        })
        .finally(() => {
          this.pegarInfoUsuario();
        });
    },
    pegarInfoUsuario() {
      const {
        cdUnimed,
        cpf,
        email,
        nome,
        nomeUnimed,
        tipoUnimed,
        papel
      } = this.objetoUsuario;

      this.objetoUsuarioHeader = {
        cdUnimed,
        cpf,
        email,
        nome,
        nomeUnimed,
        tipoUnimed,
        papel: papel.descricao,
        unimed: cdUnimed + " - " + nomeUnimed
      };
    }
  },
  computed: {
    /**
     * Computed que retorna as informações do Usuário
     * @return { {"cpf": String,"email": String,"nome": String,"papel": "{ "chave": String, "descricao": String }","nomeUnimed": String,"cdUnimed": Number} } objeto do usuário
     */
    objetoUsuario() {
      return this.$store.getters.getObjetoUsuario;
    },
    mostrarBread() {
      return this.$store.getters.getMostrarBread;
    },
    breadcrumb() {
      return this.$store.getters.getBread;
    },
    objetoPerfilComputed() {
      const { nome, email, cpf, papel } = this.objetoUsuarioHeader;

      return {
        nome: {
          destacado: true,
          value: nome
        },
        email,
        documento: cpf,
        perfil: papel
      };
    },
    objetoUnimedComputed() {
      const { unimed, tipoUnimed } = this.objetoUsuarioHeader;

      return {
        minhaUnimed: {
          destacado: true,
          value: "Minha unimed"
        },
        unimed: {
          chave: "Unimed",
          value: unimed
        },
        tipo: {
          chave: "Tipo",
          value: tipoUnimed
        }
      };
    },
    listaBotoesComputed() {
      return ["Sair"];
    }
  },
  watch: {
    objetoUsuario() {
      if (Object.keys(this.objetoUsuario).length === 0) return;
      this.pegarInfoUsuario();
    }
  }
};
